import { dedent } from 'ts-dedent';
import { SINGLE_OUTPUT_NAME, SingleOutputWorkflowComponent } from './singleoutputcomponent';
// A workflow component that represents a transformation that can be expressed with a SELECT query
export class SelectWorkflowComponent extends SingleOutputWorkflowComponent {
    constructor(metadata, inputs) {
        super(metadata, inputs);
    }
    async getCode(componentCodeParams) {
        const { workflow, params, connection, codeType } = componentCodeParams;
        const preparedParams = this._prepareParameters(params);
        const select = this.getInnerSql({
            ...componentCodeParams,
            params: preparedParams
        });
        if (select !== null) {
            const tablename = connection.getOutputTableName(workflow.id, this.metadata.name, params, SINGLE_OUTPUT_NAME, codeType);
            let query = '';
            query = connection.getCreateTempTableQuery(tablename, dedent(select), codeType, null);
            return {
                query,
                outputs: { result: tablename }
            };
        }
        else {
            return null;
        }
    }
}
